/**
 * Critical JavaScript - Loads first on every page
 * Initializes cart state and scroll animations
 */

import { updateCartBubble } from '@theme/utilities';
import { initScrollAnimations } from '@theme/scroll-animations';

initScrollAnimations();

document.addEventListener('DOMContentLoaded', () => {
  updateCartBubble();
});

// Sitewide details script to ensure no overlap with other same page details containers



